import React, { useCallback } from 'react';
import Particles from 'react-tsparticles';
//import { loadFull } from 'tsparticles';
import { loadSlim } from "tsparticles-slim";

function ParticlesComponent() {
  const particlesInit = useCallback(async (engine) => {
    console.log(engine);
        await loadSlim(engine);
        //await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
        await console.log(container);
  }, []);

  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: -1 }}>
    <Particles
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                background: {
                  image: "linear-gradient(90deg, #DE26A0 0%, #068FF1 50%)"
                  //image: "linear-gradient(90deg, #7248ce 0%, #342452 75%)"
                },
                fpsLimit: 120,
                interactivity: {
                    events: {
                        onClick: {
                            enable: true,
                            mode: "push",
                        },
                        onHover: {
                            enable: true,
                            mode: "repulse",
                        },
                        resize: true,
                    },
                    modes: {
                        push: {
                            quantity: 4,
                        },
                        repulse: {
                            distance: 100,
                            duration: 0.4,
                        },
                    },
                },
                particles: {
                    color: {
                        value: "#ffffff",
                    },
                    links: {
                        color: "#ffffff",
                        distance: 150,
                        enable: true,
                        opacity: 0.5,
                        width: 1,
                    },
                    move: {
                        direction: "none",
                        enable: true,
                        outModes: {
                            default: "bounce",
                        },
                        random: false,
                        speed: 6,
                        straight: false,
                    },
                    number: {
                        density: {
                            enable: true,
                            area: 800,
                        },
                        value: 80,
                    },
                    opacity: {
                        value: 0.5,
                    },
                    shape: {
                        type: "circle",
                    },
                    size: {
                        value: { min: 1, max: 5 },
                    },
                },
                detectRetina: true,
            }}
        />
    </div>
  );
}

export default ParticlesComponent;
